// src/components/Header.js
import React from "react";
import { NavLink } from "react-router-dom";

export default function Header() {
  return (
    <header className="bg-blue-700 text-white p-4 flex justify-between items-center">
      <h1 className="text-xl font-bold">Tienda Deportiva</h1>
      <nav className="space-x-6">
        <NavLink
          to="/"
          className={({ isActive }) =>
            isActive ? "underline font-semibold" : "hover:underline"
          }
        >
          Inicio
        </NavLink>
        <NavLink
          to="/productos"
          className={({ isActive }) =>
            isActive ? "underline font-semibold" : "hover:underline"
          }
        >
          Productos
        </NavLink>
        <NavLink
          to="/contacto"
          className={({ isActive }) =>
            isActive ? "underline font-semibold" : "hover:underline"
          }
        >
          Contacto
        </NavLink>
      </nav>
    </header>
  );
}
